// removed by extract-text-webpack-plugin
module.exports = {"Modal":"ClientInfo__Modal__1qiBp"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/TrackingPage/ClientInfo/ClientInfo.css
// module id = 408
// module chunks = 0